import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import useRazorpay, { RazorpayOptions } from 'react-razorpay';
import { toast } from 'react-toastify';
import Layout from '../../wrappers/layout';

import IndicatorCard from '../dashboard/components/indicator-card';
import PageHeader from '../../shared/page-header';
import AddWithdrawMoney from './components/add-withdraw-money';
import { passbookStore } from '../../store/PassbookStore';
import PassbookService from '../../services/passbook.service';
import WalletService from '../../services/wallet.service';
import WalletTransactions from '../passbook/components/wallet-Transactions';
import { Pagination } from '../../shared/common/pagination';
import Toast from '../../shared/common/toast';
import DashboardService from '../../services/dashboard.service';
import { dashboardStore } from '../../store/DashboardStore';
import { userStore } from '../../store/UserStore';
import Loader from '../../shared/common/loader';
import OtpModal from '../../shared/common/modal/otp_modal';
import { formatAmount } from '../../utils';
import buySellService from 'services/buy-sell.service';
import RedirectToast from 'shared/common/toast/redirectToast';
import { useHistory } from 'react-router-dom';
import format from 'string-template';
import {
  ACK_FAIL,
  ACK_SUCCESS,
  OTP_SENT_TO_REG_MESSAGE,
  OTP_VERIFY_FAILURE,
  OTP_VERIFY_SUCCESS,
} from 'constants/messages.constant';
import OtpPopup from 'shared/common/otp-modal/otpModal';
import NomineeModal from 'pages/profile/components/NomineeModal';
import SupportButton from 'shared/common/supportButton/SupportButton';

const types = [
  { name: 'UPI', value: 'UPI' },
  { name: 'Net Banking', value: 'NEBK' },
];

interface PropsType {}

/* eslint-disable */
const Wallet: React.FC<PropsType> = () => {
  const Razorpay = useRazorpay();
  const history = useHistory();
  const [showVaDetails, setShowVaDetails] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [metaData, setMetaData] = useState<any>({});
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [loading, setLoading] = useState<any>(true);
  const [type, setType] = useState('UPI');
  const [provider, setProvider] = useState('');
  const [modalShow, setModalShow] = React.useState(false);
  const [txtSuscces, setTxtSuscces] = useState('');
  const [transactionId, setTransactionId] = useState('');
  const [txtError, setTxtError] = useState('');
  const [otpMeta, setOtpMeta] = useState<any>({
    otpId: '',
    otp: '',
  });
  const [otpData, setOtpData] = useState<OtpData>({
    value: '',
    ackMessage: '',
    ackMessageType: 'success',
  });
  const [user] = userStore((state: any) => [state.user]);

  useEffect(() => {
    if (otpData.value?.length === 6) verifyOtp();
  }, [otpData.value]);

  const resetOtpData = () => {
    setOtpData({
      value: '',
      ackMessage: '',
      ackMessageType: 'success',
    });
  };

  const [customerId, userData, customer, selectedAccount] = userStore(
    (state: any) => [
      state.customerId,
      state.userData,
      state.customer,
      state.selectedAccount,
    ]
  );

  const [dbs, setDBS] = useState<any>({
    customerId: customerId,
    amount: '',
    receiver: {
      upi: customer?.upiDetails?.accountNo,
      name: customer?.upiDetails?.name,
    },
  });

  const [razorpay, setRazorpay] = useState<any>({
    transactionType: 'WALLET',
    transactionMethod: type,
    referenceId: customerId,
    referenceType: 'CUSTOMER',
    amount: '',
  });

  const [withdrawData, setWithdrawData] = useState<any>({
    transactionType: 'WALLET',
    transactionMethod: 'IMPS',
    referenceType: 'CUSTOMER',
    referenceId: customerId,
    amount: '',
    currency: 'INR',
    meta: {
      otp: {
        id: otpMeta.otpId,
        otp: '',
      },
    },
    // receiver: {
    //   name: customer.bankDetails.nameAsOnBankAcount,
    //   bankAccount: customer.bankDetails.bankAccount,
    //   ifsc: customer.bankDetails.ifsc,
    //   bankName: customer.bankDetails.bankName,
    // },
  });

  // eslint-disable-next-line
  const [walletTransactions, setWalletTransactions] = passbookStore(
    (state: any) => [state.walletTransactions, state.setWalletTransactions]
  );

  // eslint-disable-next-line
  const [summary, wallet, setSummary, setWallet] = dashboardStore(
    (state: any) => [
      state.summary,
      state.wallet,
      state.setSummary,
      state.setWallet,
    ]
  );

  useEffect((): any => {
    document.title = 'Wallet - eBullion';
    getPassbookSummary();
    getWalletTransactions(currentPage);
    // getUPIProvider();
    // eslint-disable-next-line
  }, []);

  useEffect((): any => {
    setRazorpay({
      ...razorpay,
      partnerId: wallet.partnerId,
    });
  }, [wallet]);

  useEffect((): any => {
    setWithdrawData({
      ...withdrawData,
      meta: {
        otp: {
          id: otpMeta.otpId,
          otp: '',
        },
      },
    });
  }, [otpMeta]);

  /**
   * Handle payments using razorpay payment gateway
   */
  const handlePayment = async () => {
    if (razorpay.amount > 500000) {
      setShowVaDetails(true);
    } else {
      try {
        const payload = {
          transactionType: 'WALLET',
          transactionMethod: type,
          referenceId: razorpay.referenceId,
          referenceType: 'CUSTOMER',
          amount: razorpay.amount,
        };

        const options: RazorpayOptions = {
          key: process.env.REACT_APP_RAZORPAY_KEY,
          amount: '',
          currency: 'INR',
          name: 'eBullion',
          description: 'Add Funds to Wallet',
          image:
            'https://ebullion-dev.s3.ap-south-1.amazonaws.com/assets/eb-logo.png',
          order_id: '',
          async handler(response: any) {
            // const res: any = await WalletService.verifyUPIANDNEBT(payload);
            // if (res.status === 200 && res.data.data) {
            await getWalletTransactions(currentPage);
            await getPassbookSummary();
            setInitialStateRazorpay();
            return toast.success('Payment was successfully updated');
            // }
          },
          prefill: {
            name: userData.given_name,
            email: userData.email,
            contact: userData.phone_number,
            method: type === 'UPI' ? 'upi' : 'netbanking',
          },
          notes: {
            address: selectedAccount.billingAddress.address1,
          },
          theme: {
            hide_topbar: false,
            color: '#141034',
            backdrop_color: 'rgba(0, 0, 0, 0.90)',
          },
          timeout: 180,
        };

        // if (!razorpay.amount) return toast.error('Please enter an amount!');
        // setLoading(true);
        // const res: any = await WalletService.add(payload);
        // let razorpayClone = { ...razorpay };
        // razorpayClone.amount = Number(razorpayClone.amount);
        // // const res: any = await WalletService.orderRazorpayUPI(razorpayClone);
        // setIsLoading(false);
        // return openPaymentWindow(res, options);

        if (type === 'UPI') {
          // if (Object.keys(customer.upiDetails).length === 0
          //     || customer.upiDetails.state === 'REJECTED' || customer.upiDetails.state === 'PENDING') return toast.error('Please verify your UPI details');
          if (!customer.upiDetails?.state) {
            let default_ac = {
              referenceId: customerId,
              type: 'UPI',
            };
            setLoading(true);
            const response: any = await buySellService.createDefaultAccount(
              default_ac
            );
            setLoading(false);

            if (response.status === 200 && response.data.data) {
              setIsLoading(true);
              const res: any = await WalletService.add(payload, user?.userId);
              setProvider(
                res?.data.data.meta.filter(
                  (data: any) => data.key === 'PAYMENT_PROVIDER'
                )[0].value || ''
              );
              if (res?.data.data.status === 'REJECTED') {
                setIsLoading(false);
                toast.error(
                  res?.data.data.meta.filter(
                    (data: any) => data.key === 'ERROR_MESSAGE'
                  )[0].value
                );
              }
              if (
                'RPY' ===
                res?.data.data.meta.filter(
                  (data: any) => data.key === 'PAYMENT_PROVIDER'
                )[0].value
              ) {
                setLoading(true);
                let razorpayClone = { ...razorpay };
                razorpayClone.amount = Number(razorpayClone.amount);
                // const res: any = await WalletService.orderRazorpayUPI(razorpayClone);
                setIsLoading(false);
                return openPaymentWindow(res, options);
              } else {
                if (!razorpay.amount)
                  return toast.error('Please enter an amount!');
                await getWalletTransactions(currentPage);
                await getPassbookSummary();
                setInitialStateRazorpay();
                setLoading(false);
                setIsLoading(false);
                return toast.success('Payment was successfully updated!');
              }
            }
          } else {
            setIsLoading(true);
            const res: any = await WalletService.add(payload, user?.userId);

            setProvider(
              res?.data.data.meta.filter(
                (data: any) => data.key === 'PAYMENT_PROVIDER'
              )[0].value || ''
            );
            if (res?.data.data.status === 'REJECTED') {
              setIsLoading(false);
              toast.error(
                res?.data.data.meta.filter(
                  (data: any) => data.key === 'ERROR_MESSAGE'
                )[0].value
              );
            }
            if (
              'RPY' ===
              res?.data.data.meta.filter(
                (data: any) => data.key === 'PAYMENT_PROVIDER'
              )[0].value
            ) {
              setLoading(true);
              let razorpayClone = { ...razorpay };
              razorpayClone.amount = Number(razorpayClone.amount);
              // const res: any = await WalletService.orderRazorpayUPI(razorpayClone);
              setIsLoading(false);
              return openPaymentWindow(res, options);
            } else {
              if (!razorpay.amount)
                return toast.error('Please enter an amount!');
              await getWalletTransactions(currentPage);
              await getPassbookSummary();
              setInitialStateRazorpay();
              setLoading(false);
              setIsLoading(false);
              return toast.success('Payment was successfully updated!');
            }
          }
        }

        if (type === 'NEBK') {
          // if (Object.keys(customer.bankDetails).length === 0
          //     || (customer.bankDetails.state === 'REJECTED' || customer.bankDetails.state === 'PENDING')) return toast.error('Please verify your bank details');
          if (!customer.bankDetails?.state) {
            let default_ac = {
              referenceId: customerId,
              type: 'BANK',
            };
            setLoading(true);
            const res: any = await buySellService.createDefaultAccount(
              default_ac
            );
            setLoading(false);

            if (res.status === 200 && res.data.data) {
              setIsLoading(true);
              const res: any = await WalletService.add(payload, user?.userId);
              setLoading(true);
              let razorpayClone = { ...razorpay };
              razorpayClone.amount = Number(razorpayClone.amount);
              // const res: any = await WalletService.orderRazorpayNetBanking(razorpayClone);
              setIsLoading(false);
              return openPaymentWindow(res, options);
            }
          } else {
            setIsLoading(true);
            const res: any = await WalletService.add(payload, user?.userId);
            setLoading(true);
            let razorpayClone = { ...razorpay };
            razorpayClone.amount = Number(razorpayClone.amount);
            // const res: any = await WalletService.orderRazorpayNetBanking(razorpayClone);
            setIsLoading(false);
            return openPaymentWindow(res, options);
          }
        }
      } catch (err: any) {
        setLoading(false);
        setIsLoading(false);
        if (err.data.errors.length > 0)
          return toast.error(err.data.errors[0].title);
        return toast.error('Something went wrong');
      }
    }
  };

  /**
   * Set type value
   * @param e
   */
  const onChangeType = (e) => {
    setType(e.currentTarget.value);
    setRazorpay({
      ...razorpay,
      transactionMethod: e.currentTarget.value,
    });
  };

  /**
   * Open payment gateway window
   * @param result
   * @param options
   */
  const openPaymentWindow = (result: any, options: any) => {
    if (result.status === 200 && result.data.data.meta.length > 0) {
      setLoading(false);
      options.amount = razorpay.amount.toString();
      options.order_id = result.data.data.meta[0].value;
      const razorPay = new Razorpay(options);
      return razorPay.open();
    }
  };

  /**
   * Set amount value
   * @param name
   * @param value
   * @param isAdd
   */
  const onChangeAmount = (value, name, isAdd) => {
    if (isAdd) {
      setRazorpay({
        ...razorpay,
        [name]: value,
      });
      // if (type === 'UPI' && provider === 'DBS') {
      //   setDBS({
      //     ...dbs,
      //     [name]: value,
      //   });
      // } else {
      //   setRazorpay({
      //     ...razorpay,
      //     [name]: value,
      //   });
      // }
    } else {
      setWithdrawData({
        ...withdrawData,
        [name]: value,
      });
    }
  };

  /**
   * Get wallet transactions
   * @param page
   */
  const getWalletTransactions = async (page: number) => {
    setLoading(true);
    try {
      const res: any = await PassbookService.getWalletTransactions(
        customerId,
        page,
        user?.userId
      );
      if (res.status === 200 && res.data.data.result) {
        setCurrentPage(page);
        setMetaData({
          current: res.data.meta.page,
          pages: res.data.meta.totalPages,
        });
        setWalletTransactions(res ? res.data.data.result : []);
      }
    } catch (e: any) {
      return toast.error('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  /**
   * Get passbook summary details
   */
  const getPassbookSummary = async () => {
    setLoading(true);
    try {
      const res: any = await DashboardService.getPassbookSummary(
        customerId,
        user?.userId
      );
      if (res.status === 200 && res.data.data) {
        setSummary(res.data.data.summary);
        setWallet(res.data.data.wallet);
      }
    } catch (e: any) {
      console.log(e.message);
    } finally {
      setLoading(false);
    }
  };

  /**
   * Get UPI Provider
   */
  const getUPIProvider = async () => {
    try {
      const res: any = await WalletService.getUPIProvider();
      if (res.status === 200 && res.data.data) {
        setProvider(res.data.data.provider);
      }
    } catch (e: any) {
      return toast.error('Something went wrong');
    }
  };

  /**
   * Withdraw money from account
   */
  const withdraw = async () => {
    try {
      if (!withdrawData.amount)
        return toast.error('Please enter a valid amount');
      if (withdrawData.amount > summary.walletBalance)
        return toast.error('Wallet balance is not enough');
      // if (withdrawData.amount < 100)
      //   return toast.error('Amount should be greater than ₹100');
      // check customer bank account is verified
      if (
        Object.keys(customer.bankDetails).length === 0 ||
        customer.bankDetails.state === 'REJECTED' ||
        customer.bankDetails.state === 'PENDING' ||
        customer.bankDetails.state === 'VERIFICATION_PENDING' ||
        !customer.bankDetails.accountNo
      )
        return toast.error(
          <RedirectToast
            btnLabel='Go to Profile'
            label='Please verify your bank details'
            showButton
            onBtnClick={() => {
              history.push('/profile?bank=true');
            }}
          />,
          { closeOnClick: false }
        );
      // setLoading(true);
      setIsLoading(true);
      const data = await WalletService.requestOtp(
        {
          customerId: customerId,
          otpReferenceType: 'WALLET_WITHDRAW',
        },
        user?.userId
      );

      if (data.status === 200 && data.data.data) {
        setIsLoading(false);
        setOtpMeta({
          ...otpMeta,
          otp: data.data.data.otp,
          otpId: data.data.data.otpId,
        });
        resetOtpData();
        setLoading(false);
        setTxtError('');
        setTxtSuscces('OTP has been sent to the registered mobile');

        setModalShow(true);
        setIsOtpVerified(false);
        return toast.success('OTP has been sent to the registered mobile');
      }
      return toast.error('Something went wrong');
    } catch (error: any) {
      console.log(error);
      setIsLoading(false);
      setLoading(false);
      if (
        error &&
        error.data &&
        error.data.errors &&
        error.data.errors.length > 0
      ) {
        return toast.error(error.data.errors[0].title);
      }
      return toast.error('Something went wrong');
    }
  };

  /**
   * Set initial state to dbs data
   */
  const setInitialStateDBS = () => {
    setDBS({
      referenceId: customerId,
      referenceType: 'CUSTOMER',
      amount: '',
      receiver: {
        upi: customer.upiDetails.upi,
        name: customer.upiDetails.nameAsOnUPI,
      },
    });
  };

  /**
   * Set initial state to withdraw data
   */
  const setInitialStateWithdrawData = () => {
    setWithdrawData({
      transactionType: 'WALLET',
      transactionMethod: 'IMPS',
      referenceType: 'CUSTOMER',
      referenceId: customerId,
      amount: '',
      currency: 'INR',
      meta: {
        otp: {
          id: '',
          otp: '',
        },
      },
      // customerId: customerId,
      // amount: "",
      // currency: 'INR',
      // receiver: {
      //   name: customer.bankDetails.nameAsOnBankAcount,
      //   bankAccount: customer.bankDetails.bankAccount,
      //   ifsc: customer.bankDetails.ifsc,
      //   bankName: customer.bankDetails.bankName,
      // },
    });
  };

  /**
   * Set initial state to razorpay data
   */
  const setInitialStateRazorpay = () => {
    setRazorpay({
      referenceId: customerId,
      amount: '',
      currency: 'INR',
      transactionMethod: 'UPI',
    });
  };

  const verifyOtp = async () => {
    try {
      setLoading(true);

      let res: any = null;
      if (customer.customerCategory !== 'REGISTERED') {
        // res = await WalletService.withdraw({
        res = await WalletService.withdrawPending(
          {
            // res = await WalletService.withdraw({
            ...withdrawData,
            meta: {
              otp: { ...withdrawData.meta.otp, otp: parseInt(otpData?.value) },
            },
          },
          user?.userId
        );
      } else {
        res = await WalletService.withdrawPending(
          {
            ...withdrawData,
            meta: {
              otp: { ...withdrawData.meta.otp, otp: parseInt(otpData?.value) },
            },
          },
          user?.userId
        );
      }
      setLoading(false);
      if (res.status == 200 && res.data) {
        setModalShow(false);
        setIsOtpVerified(true);
        setOtpMeta({
          otpId: '',
          otp: '',
        });
        setWithdrawData({ ...withdrawData, amount: '' });
        setOtpData({
          ...otpData,
          ackMessage: OTP_VERIFY_SUCCESS,
          ackMessageType: ACK_SUCCESS,
        });
        await getWalletTransactions(currentPage);
        await getPassbookSummary();
        toast.success('Money will be credited to your bank account within 24 hrs');
        if (customer.customerCategory === 'REGISTERED') {
          if (
            res.data?.data?.status &&
            res.data?.data?.status === 'TRANSACTION_APPROVAL_PENDING'
          ) {
            toast.info('Your transaction will be approved within 4 hours.', {
              autoClose: false,
            });
          }
        }
      }
    } catch (error: any) {
      setLoading(false);
      if (error?.data?.errors[0]?.title === 'OTP invalid') {
        setOtpData({
          value: '',
          ackMessage: OTP_VERIFY_FAILURE,
          ackMessageType: ACK_FAIL,
        });
        toast.error(OTP_VERIFY_FAILURE);
        setIsOtpVerified(false);
      } else {
        toast.error(error?.data?.errors[0]?.title);
        setModalShow(false);
      }
    }
  };
  const sendOtp = async () => {
    try {
      setLoading(true);
      const res: any = await WalletService.requestOtp(
        {
          customerId: customerId,
          otpReferenceType: 'WALLET_WITHDRAW',
        },
        user?.userId
      );
      if (res) {
        setOtpMeta({
          ...otpMeta,
          otp: res.data.data.otp,
          otpId: res.data.data.otpId,
        });
        setTxtError('');
        setTxtSuscces('OTP has been resent to the registered mobile');
        setModalShow(true);
        setIsOtpVerified(false);
        setLoading(false);
        return;
      }
    } catch (error: any) {
      setLoading(false);
      if (
        error &&
        error.data &&
        error.data.errors &&
        error.data.errors.length > 0
      ) {
        setTxtError(error.data.errors[0].title);
        return toast.error(error.data.errors[0].title);
      }
      return toast.error('Something went wrong');
    }
  };

  const handleVaClose = () => {
    setShowVaDetails(false);
  };

  return (
    <Layout>
      <div>
        <PageHeader
          mainTitle='My Wallet'
          subTitle='Below are your transaction details'
          isShowSub={false}
        />
        {loading ? <Loader /> : null}
        <Row>
          <Col md={8}>
            <div className='my-1 col col-sm-12 col-md-6 '>
              <IndicatorCard
                isMain
                heading='In Wallet'
                amount={`₹ ${
                  summary.walletBalance
                    ? formatAmount(summary.walletBalance)
                    : '0.00'
                }`}
                styles=''
                addClassName='wallet'
                earmarkedBalance={`₹ ${formatAmount(wallet.lockBalance)}`}
              />
              {/*<div>
                          <IndicatorCard
                              isMain={false}
                              heading="Silver"
                              amount="470,000,00"
                              styles={{
                                color: 'black',
                                textAlign: 'right',
                              }}
                              quantity="20 g"
                              additionalData="Past Transactions"
                          />
                        </div>*/}
            </div>
            <Row className='mt-3'>
              <Col md={12}>
                <h5>Past wallet Transactions</h5>
                <div className='t-wrap overflow-auto'>
                  <WalletTransactions walletData={walletTransactions} />
                </div>
                <Row>
                  <Col md={12}>
                    {/* Pagination Bar */}
                    {!loading && (
                      <Pagination
                        meta={metaData}
                        handlePageChange={(number: number) =>
                          getWalletTransactions(number)
                        }
                      />
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col md={4} className='py-2'>
            <AddWithdrawMoney
              isLoading={isLoading}
              types={types}
              type={type}
              provider={provider}
              onChangeType={onChangeType}
              onChangeAmount={onChangeAmount}
              onSubmit={handlePayment}
              onWithdraw={withdraw}
              customer={customer}
              selectedAccount={selectedAccount}
              dbs={dbs}
              withdrawData={withdrawData}
              razorpay={razorpay}
            />
          </Col>
        </Row>
      </div>
      <OtpModal
        show={modalShow}
        handleClose={() => setModalShow(false)}
        title='Enter the OTP sent your registered mobile number'
        onSuccess={(otp) => verifyOtp()}
        resend={sendOtp}
        txtSuscces={txtSuscces}
        txtError={txtError}
        isVerified={isOtpVerified}
        loading={loading}
        // autoFillOTP={otpMeta.otp}
      />
      <OtpPopup
        show={modalShow}
        isLoading={loading}
        handleClose={() => {
          resetOtpData();
          setModalShow(false);
        }}
        modalTitle={`Withdraw Amount Confirmation`}
        modalSubmitBtnText='Verify'
        onSubmit={() => verifyOtp()}
        otpLabel={format(OTP_SENT_TO_REG_MESSAGE, {
          suffixDigits: user?.mobile?.value?.slice(-4),
        })}
        enableResendTimer={true}
        resendHandler={() => {
          resetOtpData();
          sendOtp();
        }}
        otpChangeHandler={(value) => {
          setOtpData({
            value: value,
            ackMessage: '',
            ackMessageType: 'success',
          });
        }}
        resendButtonText='Resend OTP'
        ackMessage={otpData.ackMessage}
        ackMessageType={otpData.ackMessageType}
        numInputs={6}
        otpValue={otpData.value}
        resendInterval={30}
      />

      <Modal
        show={showVaDetails}
        onHide={handleVaClose}
        backdrop='static'
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Wallet Top-up</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Please transfer the funds to below account using NEFT or RTGS. </p>
          <small>
            <ul>
              <li>
                <p className='text-muted '>
                  The Account type shall be "Current Account"
                </p>
              </li>
            </ul>
          </small>
          <Row>
            <Col md={12}>
              <Form.Group className='mb-3' controlId='va-name'>
                <Form.Label>Beneficiary Name</Form.Label>
                <Form.Control
                  disabled
                  type='text'
                  value={selectedAccount?.displayName || 'NA'}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className='mb-3' controlId='va-account-no'>
                <Form.Label>Account Number</Form.Label>
                <Form.Control
                  disabled
                  type='text'
                  value={`9EBL${customerId}`}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className='mb-3' controlId='va-ifsc'>
                <Form.Label>IFSC Code</Form.Label>
                <Form.Control disabled type='text' value={'DBSS0IN0811'} />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className='mb-3' controlId='va-bank-name'>
                <Form.Label>Bank Name</Form.Label>
                <Form.Control
                  disabled
                  type='text'
                  value={'DBS Bank India Limited'}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <small>
              <p className='text-muted '>
                (Please refresh this page once you receive acknowledgement
                message from bank)
              </p>
            </small>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleVaClose}>
            Close
          </Button>
          {/* <Button variant='primary'>Close</Button> */}
        </Modal.Footer>
      </Modal>
      {/* {customer.customerCategory === 'UNREGISTERED' &&
        customer?.nomineeDetails?.length < 1 && <NomineeModal />} */}
      <SupportButton />
    </Layout>
  );
};

export default Wallet;
